// Per-pipeline copy + palette + defaults.
// Shared by PipelineHome.js and consumed via `usePipelineConfig(key)`.
// Keeping this in one file means adding a new pipeline is a two-line change.

import { Salad, Coffee, Dumbbell, Mountain, Users } from "lucide-react";

export const PIPELINE_CONFIGS = {
  b2c_coffee: {
    key: "b2c_coffee",
    brand: "kairosa",
    label: "Kairosa Coffee",
    kicker: "Coffee · direct-to-consumer",
    tagline: "B2C pipeline for Kairosa Coffee",
    description:
      "Consumer coffee leads — subscribers, gift orders, and single-origin trials. Every " +
      "lead here was moved out of the B2C Intelligence staging pool and belongs to the " +
      "Coffee product line only.",
    icon: Coffee,
    accentClass: "text-amber-600 dark:text-amber-300",
    routePath: "/app/b2c/coffee",
  },
  b2c_jaydiets: {
    key: "b2c_jaydiets",
    brand: "jaydiets",
    label: "JAYDIETs",
    kicker: "Nutrition & Dietetics · JAYDIETs brand",
    tagline: "Global sales engine for JAYDIETs",
    description:
      "Dedicated pipeline for gyms, health coaches, dietitians, and individuals seeking " +
      "personalised nutrition. Every lead here is tagged `pipeline=b2c_jaydiets` and never " +
      "mixes with your other consumer pipelines.",
    icon: Salad,
    accentClass: "text-emerald-600 dark:text-emerald-300",
    routePath: "/app/jaydiets",
  },
  b2c_wellness: {
    key: "b2c_wellness",
    brand: "kairosa",
    label: "Wellness Training",
    kicker: "Workout & Wellness · 1-on-1 sessions",
    tagline: "Personalised wellness training bookings",
    description:
      "Consumer bookings for workout + mindfulness sessions across your studio and " +
      "partner cities. Automate the free-first-session hook and let the pipeline warm.",
    icon: Dumbbell,
    accentClass: "text-fuchsia-600 dark:text-fuchsia-300",
    routePath: "/app/b2c/wellness",
  },
  b2c_retreat: {
    key: "b2c_retreat",
    brand: "kairosa",
    label: "Wellness Retreats",
    kicker: "Retreat & Travel · Himalayan reset weeks",
    tagline: "Curated wellness retreats & travel",
    description:
      "5-7 day retreat prospects — small cohorts, high AOV. Slow-burn 12-step sequence " +
      "keeps the offer warm without spam.",
    icon: Mountain,
    accentClass: "text-sky-600 dark:text-sky-300",
    routePath: "/app/b2c/retreat",
  },
};

export function getPipelineConfig(pipelineKey) {
  return PIPELINE_CONFIGS[pipelineKey] || PIPELINE_CONFIGS.b2c_jaydiets;
}
